"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTrendsTranslate = void 0;
exports.defaultTrendsTranslate = {
    trend: 'Trends',
    noOfTransactions: '# Transactions',
    noChartData: '(*) No data for this building',
    noData: 'No Chart data',
    showingDataOf: 'Showing data of {0}',
    transactionActivities: 'Transaction Activity'
};
